import { render, staticRenderFns } from "./AgIcon.vue?vue&type=template&id=4dabceaa&scoped=true&"
import script from "./AgIcon.vue?vue&type=script&lang=js&"
export * from "./AgIcon.vue?vue&type=script&lang=js&"
import style0 from "./AgIcon.vue?vue&type=style&index=0&id=4dabceaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabceaa",
  null
  
)

export default component.exports